@if (!thread?.dateArchived || thread?.id === 'new') {
  <div class="chat-form-container">
    <div class="chat-form-start text-left pl-2">
      <button mat-raised-button (click)="handleScrollDown()" matTooltip="Scroll down" class="scroll-button">
        <mat-icon>arrow_downward</mat-icon>
      </button>
    </div>
    <div class="chat-form-center fill" [formGroup]="form">
      <mat-form-field appearance="outline" class="w-full" style="padding: 0px; padding-right: 8px">
        <textarea
          matInput
          #textMessage
          formControlName="message"
          [rows]="message.length > 100 ? 4 : 1"
          placeholder="Type your message here..."
          style="width: 100% !important; margin-right: 8px; margin-bottom: 16px"
          [maxlength]="500">
        </textarea>
        <mat-hint align="end">{{ message.length }}/500 characters</mat-hint>
      </mat-form-field>
    </div>
    <div class="chat-form-end text-right">
      <button
        mat-raised-button
        class="send-message-button"
        [disabled]="isSendingMessage || !form.valid"
        (click)="handleSendMessage()">
        Send
      </button>
    </div>
  </div>
}
